import { CAPSULE_NAME_MAX_LENGTH } from '../../types/shopCapsule';

export const SHOP_LINE_MAX_LENGTH = 140;
export const MAX_SOCIAL_LINKS = 5;
export const BIO_MAX_LENGTH = 250;

export function characterCount(text: string): number {
    return [...text.trim()].length;
}

export function lineError(line: string): string | undefined {
    return characterCount(line) > SHOP_LINE_MAX_LENGTH
        ? `Your line is over ${SHOP_LINE_MAX_LENGTH} characters. Shorten it to save.`
        : undefined;
}

export function bioError(bio: string): string | undefined {
    return characterCount(bio) > BIO_MAX_LENGTH ? `Your bio is over ${BIO_MAX_LENGTH} characters.` : undefined;
}

export function capsuleNameError(name: string): string | undefined {
    const trimmed = name.trim();
    if (!trimmed) {
        return 'Give your capsule a name.';
    }
    return [...trimmed].length > CAPSULE_NAME_MAX_LENGTH
        ? `That name is over ${CAPSULE_NAME_MAX_LENGTH} characters.`
        : undefined;
}

export type ProfileFields = {
    firstName: string;
    lastName: string;
    bio: string;
};

export type ProfileErrors = Partial<Record<keyof ProfileFields, string>>;

export function profileErrors(fields: ProfileFields, current: ProfileFields): ProfileErrors {
    const errors: ProfileErrors = {};
    if (!fields.firstName.trim()) {
        errors.firstName = 'Add your first name.';
    }
    const clearsSavedLastName = Boolean(current.lastName) && !fields.lastName.trim();
    if (clearsSavedLastName) {
        errors.lastName = 'Add your last name.';
    }
    const bio = bioError(fields.bio);
    if (bio) {
        errors.bio = bio;
    }
    return errors;
}
